import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UpcomingOrdersWithMissingContent } from './../../models';

@Injectable({
  providedIn: 'root'
})
export class UpcomingOrdersWithMissingContentService {

  constructor(private readonly httpClient: HttpClient) { }

  public getUpcomingOrdersWithMissingContent(): Observable<UpcomingOrdersWithMissingContent[]> {
    const url = 'api/upcomingOrdersWithMissingContent';
    return this.httpClient.get<UpcomingOrdersWithMissingContent[]>(url);
  }
}
